import { ModalComponent } from "cruzo/ui-components/modal";
import { appScope } from "site/api";
import type { OwnerPaymentRow } from "site/services/owner-payments-api.service";

let context: OwnerPaymentRow | null = null;

export function openOwnerPaymentReceiptModal(row: OwnerPaymentRow): void {
  context = row;
  ModalComponent.attach("ownerPaymentReceiptModal", appScope.id);
}

export function getOwnerPaymentReceiptModalContext(): OwnerPaymentRow | null {
  return context;
}

export function clearOwnerPaymentReceiptModalContext(): void {
  context = null;
}
